/** Códigos de país para WhatsApp (ordenados por longitud de código, mayor primero). */
export const PHONE_COUNTRY_CODES = [
  { code: '591', label: 'Bolivia', iso: 'BO' },
  { code: '593', label: 'Ecuador', iso: 'EC' },
  { code: '595', label: 'Paraguay', iso: 'PY' },
  { code: '598', label: 'Uruguay', iso: 'UY' },
  { code: '351', label: 'Portugal', iso: 'PT' },
  { code: '352', label: 'Luxemburgo', iso: 'LU' },
  { code: '353', label: 'Irlanda', iso: 'IE' },
  { code: '354', label: 'Islandia', iso: 'IS' },
  { code: '355', label: 'Albania', iso: 'AL' },
  { code: '356', label: 'Malta', iso: 'MT' },
  { code: '357', label: 'Chipre', iso: 'CY' },
  { code: '358', label: 'Finlandia', iso: 'FI' },
  { code: '359', label: 'Bulgaria', iso: 'BG' },
  { code: '370', label: 'Lituania', iso: 'LT' },
  { code: '371', label: 'Letonia', iso: 'LV' },
  { code: '372', label: 'Estonia', iso: 'EE' },
  { code: '373', label: 'Moldavia', iso: 'MD' },
  { code: '374', label: 'Armenia', iso: 'AM' },
  { code: '375', label: 'Bielorrusia', iso: 'BY' },
  { code: '376', label: 'Andorra', iso: 'AD' },
  { code: '377', label: 'Mónaco', iso: 'MC' },
  { code: '378', label: 'San Marino', iso: 'SM' },
  { code: '380', label: 'Ucrania', iso: 'UA' },
  { code: '381', label: 'Serbia', iso: 'RS' },
  { code: '382', label: 'Montenegro', iso: 'ME' },
  { code: '385', label: 'Croacia', iso: 'HR' },
  { code: '386', label: 'Eslovenia', iso: 'SI' },
  { code: '387', label: 'Bosnia', iso: 'BA' },
  { code: '389', label: 'Macedonia del Norte', iso: 'MK' },
  { code: '420', label: 'Rep. Checa', iso: 'CZ' },
  { code: '421', label: 'Eslovaquia', iso: 'SK' },
  { code: '502', label: 'Guatemala', iso: 'GT' },
  { code: '503', label: 'El Salvador', iso: 'SV' },
  { code: '504', label: 'Honduras', iso: 'HN' },
  { code: '505', label: 'Nicaragua', iso: 'NI' },
  { code: '506', label: 'Costa Rica', iso: 'CR' },
  { code: '507', label: 'Panamá', iso: 'PA' },
  { code: '508', label: 'San Pedro y Miquelón', iso: 'PM' },
  { code: '509', label: 'Haití', iso: 'HT' },
  { code: '51', label: 'Perú', iso: 'PE' },
  { code: '52', label: 'México', iso: 'MX' },
  { code: '53', label: 'Cuba', iso: 'CU' },
  { code: '54', label: 'Argentina', iso: 'AR' },
  { code: '55', label: 'Brasil', iso: 'BR' },
  { code: '56', label: 'Chile', iso: 'CL' },
  { code: '57', label: 'Colombia', iso: 'CO' },
  { code: '58', label: 'Venezuela', iso: 'VE' },
  { code: '1', label: 'EE.UU. / Canadá', iso: 'US' },
  { code: '34', label: 'España', iso: 'ES' },
  { code: '39', label: 'Italia', iso: 'IT' },
  { code: '44', label: 'Reino Unido', iso: 'GB' },
  { code: '49', label: 'Alemania', iso: 'DE' },
  { code: '33', label: 'Francia', iso: 'FR' },
];

export const DEFAULT_COUNTRY_CODE = '591';

const BY_CODE_LEN = [...PHONE_COUNTRY_CODES].sort(
  (a, b) => b.code.length - a.code.length
);

export const normPhoneDigits = (value) => String(value || '').replace(/\D/g, '');

export const splitPhoneDigits = (fullDigits) => {
  const digits = normPhoneDigits(fullDigits);
  if (!digits) {
    return { countryCode: DEFAULT_COUNTRY_CODE, national: '' };
  }
  for (const c of BY_CODE_LEN) {
    if (digits.startsWith(c.code)) {
      return { countryCode: c.code, national: digits.slice(c.code.length) };
    }
  }
  return { countryCode: DEFAULT_COUNTRY_CODE, national: digits };
};

export const buildFullPhone = (countryCode, national) => {
  const cc = normPhoneDigits(countryCode);
  const nn = normPhoneDigits(national);
  if (!cc && !nn) return '';
  return `${cc || DEFAULT_COUNTRY_CODE}${nn}`;
};

/** E.164 sin "+"; antepone 591 si el número local tiene 7–9 dígitos. */
export const normalizeFullPhone = (raw) => {
  const digits = normPhoneDigits(raw);
  if (!digits) return '';
  if (digits.length >= 10) return digits;
  if (digits.length >= 7) return buildFullPhone(DEFAULT_COUNTRY_CODE, digits);
  return '';
};

export const formatPhoneDisplay = (fullDigits) => {
  const digits = normPhoneDigits(fullDigits);
  if (!digits) return '';
  const { countryCode, national } = splitPhoneDigits(digits);
  if (!national) return `+${countryCode}`;
  return `+${countryCode} ${national}`;
};

/** Mínimo: código país + al menos 7 dígitos locales (p. ej. 591 + 7 = 10). */
export const isValidFullPhone = (fullDigits) => {
  const digits = normPhoneDigits(fullDigits);
  if (digits.length < 10) return false;
  const { national } = splitPhoneDigits(digits);
  return national.length >= 7;
};

export const whatsappHref = (fullDigits) => {
  const digits = normPhoneDigits(fullDigits);
  if (!isValidFullPhone(digits)) return null;
  return `https://wa.me/${digits}`;
};

export const countryOptionLabel = (c) =>
  c ? `+${c.code} ${c.label}` : '';

export const findCountryByCode = (code) =>
  PHONE_COUNTRY_CODES.find((c) => c.code === String(code || '').replace(/\D/g, '')) ||
  PHONE_COUNTRY_CODES.find((c) => c.code === DEFAULT_COUNTRY_CODE);
